import { RootAction, RootState, Services } from 'typesafe-actions';
import { applyMiddleware, createStore as createStoreRedux } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import * as services from '../services';
import rootEpic from './root-epic';
import rootReducer from './root-reducer';
import { composeEnhancers } from './utils';

export const createStore = (initialState: any) => {
  const epicMiddleware = createEpicMiddleware<
    RootAction,
    RootAction,
    RootState,
    Services
  >({
    dependencies: {
      ...services,
    },
  });

  // configure middlewares
  const middlewares = [epicMiddleware];
  // compose enhancers
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  // create store
  const store = createStoreRedux(rootReducer, initialState, enhancer);
  epicMiddleware.run(rootEpic);

  return store;
};
